import { defineStore } from 'pinia';
import api from '@/services/api';

export const useTintaStore = defineStore('tintaStore', {
  state: () => ({
    tintaList: [],
    tipoTintaList: [],
    page: 1,
  }),
  actions: {
    async findAllTintaHTTP() {
      const result = await api.get('/material', { params: { page: +this.page, categoria: 7 } });
      if (result && result.data) {
        this.tintaList.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async findAllTipoTintaHTTP() {
      const result = await api.get('/tinta-tipo', { params: { page: +this.page } });
      if (result && result.data) {
        this.tipoTintaList.splice(0, this.tipoTintaList.length, ...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },

    async searchTintaHTTP(query) {
      const result = await api.get('/material', {
        params: { page: 1, categoria: 7, DescripcionInterna: query },
      });
      if (result && result.data && result.data.length > 0) {
        return [...result.data];
      }
    },
    async searchTintaByColorHTTP(query, categoryCode, colorCode) {
      const params = {
        page: 1,
        categoria: categoryCode,
        sortBy: 'DescripcionInterna',
        sort: 'asc',
      };
      if (query && query.trim()) params.DescripcionInterna = query.trim();
      if (colorCode !== null && colorCode !== '' && Number.isFinite(Number(colorCode)))
        params.CodigoColor = Number(colorCode);
      const { data } = await api.get('/material', { params });
      return Array.isArray(data) ? data : [];
    },
    async searchAniloxHTTP(query) {
      const params = { page: 1, categoria: 32 };
      if (query && query.trim()) params.DescripcionInterna = query.trim();
      const { data } = await api.get('/material', { params });
      return Array.isArray(data) ? data : [];
    },
    async searchCintaHTTP(query) {
      const params = { page: 1, categoria: 3 };
      if (query && query.trim()) params.DescripcionInterna = query.trim();
      const { data } = await api.get('/material', { params });
      return Array.isArray(data) ? data : [];
    },
    async firstTinta() {
      this.setPage(1);
      this.emptyList();
      await this.findAllTintaHTTP();
    },
    async firstTipoTinta() {
      this.setPage(1);
      this.emptyList();
      await this.findAllTipoTintaHTTP();
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.tintaList = [];
    },
  },
});
